import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { KitchenModal } from '../../kitchenmodal';
// jQuery Sign $
declare let $: any;


@Component({
  selector: 'app-kitchen-details',
  templateUrl: './kitchen-details.component.html',
  styleUrls: ['./kitchen-details.component.scss']
})
export class KitchenDetailsComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: KitchenModal;
  @Input() isedit: boolean;
  @Input() displaycomname: string;
  kitchen: KitchenModal;
  kitchen_details_is_there_a_local_shutdown_of_water_plumbing: string;
  kitchen_details_is_floor_heating_available: string;
  isEditable: boolean;
  displaycomponentName: string;
  @ViewChild('accordionExampleQuestion') accordionExampleQuestion: ElementRef;
  htmlstringvalue: string;
  kitchen_details_do_you_want_to_move: Array<any> = [{ name: 'Golvbrunn' }, { name: 'Avlopp' }, { name: 'Ventilation' }];
  selectedkitchenrow: Array<any> = [];

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {

   this.htmlstringvalue = this.accordionExampleQuestion.nativeElement.innerHTML;
}

  ngOnChanges(changes: SimpleChanges) {
    this.kitchen = this.data;
    this.isEditable = this.isedit;
    this.displaycomponentName = this.displaycomname;
    if (this.data != null || this.data !== undefined) {
      this.kitchen_details_is_there_a_local_shutdown_of_water_plumbing =
        this.get_local_shutdown_of_water_plumbing(this.data.kitchen_details_is_there_a_local_shutdown_of_water_plumbing);
      this.kitchen_details_is_floor_heating_available =
        this.get_local_shutdown_of_water_plumbing(this.data.kitchen_details_is_floor_heating_available);
        this.selectedkitchenrow = this.getkitchenRow(this.data.kitchen_details_do_you_want_to_move);
    }

  }

  get_local_shutdown_of_water_plumbing(index) {
    if (Number(index) === 1) {
      return 'Ja';
    } else if (Number(index) === 2) {
      return 'Nej';
    } else if (Number(index) === 3) {
      return 'Osäker/Vill rådfråga';
    } else {
      return '';
    }
  }

  getkitchenRow(item: string) {
    // tslint:disable-next-line:prefer-const
    let returnitem: Array<any> = [];
    if (item != null) {
      // tslint:disable-next-line:prefer-const
      let itemarray = item.split(',');
      itemarray.forEach(val => {
        returnitem.push({ name: val });
      });
    }
    return returnitem;
  }




   // Question set change method accoring to
   kitchenchoosenwork_change($event) {

  }

  kitchenchoosenwork_changesub(value, propertyvalue, mainvariablevalue) {
    this[propertyvalue] = false;
    this.kitchen[mainvariablevalue] = false;
    Object.keys(this.kitchen).forEach(e => {
      if (e.indexOf(value) > -1) {
        if (this.kitchen[e]) {
          this.kitchen[mainvariablevalue] = true;
            this[propertyvalue] = true;
            return;
        }
      }
    });
  }

  // Un release the all check boxes by Un check
  kitchenchoosenwork_uncheck(value, mainvariablevalue) {
    if (!this.kitchen[mainvariablevalue]) {
      Object.keys(this.kitchen).forEach(e => {
        if (e.indexOf(value) > -1) {
          if (this.kitchen[e]) {
            this.kitchen[e] = false;
          }
          if (e.indexOf('qty') > -1) {
            this.kitchen[e] = null;
          }

          if (e.indexOf('free_text') > -1) {
            this.kitchen[e] = null;
          }
        }
      });
    }
  }

  getQuestionElement() {
    return  this.htmlstringvalue;
  }






}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/kitchen/kitchen-details/kitchen-details.component.ts